var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0.707031 0.195312)",
    fill: "white",
    fillOpacity: 0.01
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4981_457894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.20668 10.0943C1.33929 10.0943 1.46647 10.147 1.56023 10.2408C1.654 10.3346 1.70668 10.4617 1.70668 10.5943V13.0943C1.70668 13.3596 1.81204 13.6139 1.99957 13.8014C2.18711 13.989 2.44146 14.0943 2.70668 14.0943H14.7067C14.9719 14.0943 15.2263 13.989 15.4138 13.8014C15.6013 13.6139 15.7067 13.3596 15.7067 13.0943V10.5943C15.7067 10.4617 15.7594 10.3346 15.8531 10.2408C15.9469 10.147 16.0741 10.0943 16.2067 10.0943C16.3393 10.0943 16.4665 10.147 16.5602 10.2408C16.654 10.3346 16.7067 10.4617 16.7067 10.5943V13.0943C16.7067 13.6248 16.496 14.1335 16.1209 14.5085C15.7458 14.8836 15.2371 15.0943 14.7067 15.0943H2.70668C2.17625 15.0943 1.66754 14.8836 1.29247 14.5085C0.917394 14.1335 0.70668 13.6248 0.70668 13.0943V10.5943C0.70668 10.4617 0.759359 10.3346 0.853127 10.2408C0.946895 10.147 1.07407 10.0943 1.20668 10.0943Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35268 12.0483C8.39913 12.0949 8.4543 12.1318 8.51505 12.157C8.57579 12.1823 8.64091 12.1952 8.70668 12.1952C8.77245 12.1952 8.83757 12.1823 8.89831 12.157C8.95906 12.1318 9.01423 12.0949 9.06068 12.0483L12.0607 9.04834C12.1546 8.95445 12.2073 8.82711 12.2073 8.69434C12.2073 8.56156 12.1546 8.43422 12.0607 8.34034C11.9668 8.24645 11.8395 8.1937 11.7067 8.1937C11.5739 8.1937 11.4466 8.24645 11.3527 8.34034L9.20668 10.4873V1.69434C9.20668 1.56173 9.154 1.43455 9.06023 1.34078C8.96647 1.24701 8.83929 1.19434 8.70668 1.19434C8.57407 1.19434 8.4469 1.24701 8.35313 1.34078C8.25936 1.43455 8.20668 1.56173 8.20668 1.69434V10.4873L6.06068 8.34034C5.96679 8.24645 5.83946 8.1937 5.70668 8.1937C5.5739 8.1937 5.44657 8.24645 5.35268 8.34034C5.25879 8.43422 5.20605 8.56156 5.20605 8.69434C5.20605 8.82711 5.25879 8.95445 5.35268 9.04834L8.35268 12.0483Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4981_457894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.707031 0.195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d127a5dbaf27592536cdfccb52cf8a81.svg";
export { ForwardRef as ReactComponent };